import { CiSearch } from "react-icons/ci";
import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  searchUsersWithMessages,
  setUsersWithMessages,
  setUsersWithMessagesEmpty,
} from "../../../../redux-toolkit/features/slices/chatSlice/chatSlice";
import SingleItem from "./SingleItem";
import { useGetAllUserQuery } from "../../../../redux-toolkit/services/UserApi/UserApi";
import { useGetSingleAdminDataQuery } from "../../../../redux-toolkit/services/AdminApi/AdminApi";
import { LiaUsersSolid } from "react-icons/lia";

const AllUserChatsMenu = () => {

  const dispatch = useDispatch();
  const { AuthInfo } = useSelector((state) => state?.auth);
  const { usersWithMessages, onlineUsers, typingInfo, adminTypingInfo } = useSelector((state) => state?.chat);
  const { data: usersData } = useGetAllUserQuery(AuthInfo?._id, {
    skip: !AuthInfo?._id,
  });
  // console.log("usersWithMessages", usersWithMessages)
  // ========= Fetch admin data only once for typing =========
  const currentAdminEmail = adminTypingInfo?.[0]?.adminEmail;
  const { data: adminData } = useGetSingleAdminDataQuery(currentAdminEmail, {
    skip: !currentAdminEmail
  });

  useEffect(() => {
    dispatch(setUsersWithMessagesEmpty([]));
  }, []);

  useEffect(() => {
    if (usersData?.data?.length) {
      dispatch(setUsersWithMessages(usersData?.data));
    }
  }, [usersData]);


  // console.log(usersWithMessages)

  // ========= UI height set =========
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => setHeight(window.innerHeight), []);


  const handleSearch = (e) => {
    dispatch(searchUsersWithMessages(e.target.value));
  };


  return (
    <>

      <div className="live-chat-section">

        {/* Header */}
        <div className="live-chat-header">
          <LiaUsersSolid className="live-chat-header-icon" />

          <span className="live-chat-title">
            All users
          </span>

          {/* <span className="live-chat-count">
            (1)
          </span> */}
        </div>
        <div className="search-wrap">
          <div className="input-group">
            <input type="text" className="form-control"
              placeholder="Search user" onChange={handleSearch} />
            <span className="input-group-text"><CiSearch /></span>
          </div>
        </div>

        <>

          {usersWithMessages?.length ? (
            usersWithMessages.map((user) => (
              <SingleItem
                key={user._id}
                data={user}
                typingInfo={typingInfo}
                adminTypingInfo={adminTypingInfo}
                onlineUsers={onlineUsers}
                adminData={adminData?.data}
              />
            ))
          ) : (
            <p className="text-center" style={{ height: `${parseInt(height) - 100}px` }}>No users found</p>
          )}


        </>



      </div>


    </>
  );
};

export default AllUserChatsMenu;
